import { apiCall } from './gqlClient';

const GETPROVIDERMETERS_QUERY = `
  query getProviderMeters($providerId: Int!) {
    getProviderMeters(providerId: $providerId)
    {
      featureKey
			name
			unit
			granted
			consumed
			balance
      ...fragments
    }
  }`;

export const getProviderMetersApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPROVIDERMETERS_QUERY, variables: {providerId}, fragments });

const GETMETERHISTORY_QUERY = `
  query getMeterHistory($providerId: Int!, $featureKey: String!) {
    getMeterHistory(providerId: $providerId, featureKey: $featureKey)
    {
      id
			providerId
			featureKey
			delta
			eventType
			reason
			createdBy
			createdAt
      ...fragments
    }
  }`;

export const getMeterHistoryApiCall = async ({providerId, featureKey}, fragments = null) => apiCall({ query: GETMETERHISTORY_QUERY, variables: {providerId, featureKey}, fragments });

const ADJUSTMETER_QUERY = `
  mutation adjustMeter($providerId: Int!, $featureKey: String!, $delta: Int!, $reason: String, $eventType: String) {
    adjustMeter(providerId: $providerId, featureKey: $featureKey, delta: $delta, reason: $reason, eventType: $eventType)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const adjustMeterApiCall = async ({providerId, featureKey, delta, reason, eventType}, fragments = null) => apiCall({ query: ADJUSTMETER_QUERY, variables: {providerId, featureKey, delta, reason, eventType}, fragments });
